import { type UserList, createUserList } from 'models';
import { useMutation } from 'query';
import { getCommunityUsersAutocomplete } from '../../services';

export const useCommunityUsersAutocompleteMutation = () =>
  useMutation<UserList[], { communityIds: string[]; limit?: number; role?: 'admin' | 'member'; search?: string }>({
    async mutationFn({ communityIds, limit, role, search }) {
      const { data: users } = await getCommunityUsersAutocomplete({
        config: {
          params: {
            // eslint-disable-next-line @typescript-eslint/naming-convention -- key is defined by Backend API endpoint
            community_ids: communityIds,
            limit,
            role,
            scope: 'communities',
            search,
          },
        },
      });

      return users.map((user) => createUserList(user));
    },
  });
